interface SetCookieOptions {
  name: string;
  value: string;
  days?: number;
  domain?: string;
}

export const setCookie = ({
  name,
  value,
  days = 1,
  domain,
}: SetCookieOptions) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};domain=${
    domain || getRootDomain()
  };path=/`;
};

export const getCookie = (name: string): string | object | null => {
  const cookies = document.cookie.split('; ').reduce((acc, cookie) => {
    const [key, value] = cookie.split('=');
    acc[key] = decodeURIComponent(value);
    return acc;
  }, {} as Record<string, string>);

  const cookieValue = cookies[name];
  if (!cookieValue) {
    return null;
  }

  try {
    return JSON.parse(cookieValue);
  } catch {
    return cookieValue;
  }
};

export const getRootDomain = () => {
  return window.location.hostname.split('.').slice(-2).join('.');
};
